import { useState } from "react";
import { useResources } from "../../hooks/useResources";
import { useSectionDetailsStore } from "../../stores/sectionDetails.store";
import ContentHeader from "../contentHeader/ContentHeader";
import EditSectionModal from "../modal/EditSectionModal";

interface SectionDetailsHeaderProps {
  sectionId: string;
  onPreviewAll: () => void;
  previewAllCount: number;
}

const SectionDetailsHeader = ({ 
  sectionId, 
  onPreviewAll,
  previewAllCount 
}: SectionDetailsHeaderProps) => {
  const { getResourceValue } = useResources();
  const { section, load } = useSectionDetailsStore();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleEditSuccess = () => {
    // Reload section data after successful edit
    if (sectionId) {
      load(sectionId);
    }
  };

  return (
    <>
      <ContentHeader
        title={sectionId}
        headingLevel={1}
        showActions={true}
        actions={
          <>
            <button 
              className="btn btn-green" 
              onClick={onPreviewAll}
              disabled={previewAllCount === 0}
            >
              <i className="f-icon eye-icon"></i>
              {getResourceValue("preview_all", "Preview All")} ({previewAllCount})
            </button>
            <button 
              className="btn btn-white"
              onClick={handleEditClick}
            >
              <i className="f-icon edit-icon"></i>
              {getResourceValue("edit", "Edit")}
            </button>
          </>
        }
      />
      {section && (
        <EditSectionModal
          isOpen={isEditModalOpen}
          onClose={handleModalClose}
          onSuccess={handleEditSuccess}
          section={section}
        />
      )}
    </>
  );
};

export default SectionDetailsHeader;

